module.exports = __webpack_public_path__ + "img/caiji-youshi-1-0.99f1d40e.png";